import product from "./columns/product";
import one from "./columns/one";
import two from "./columns/two";
import three from "./columns/three";
import four from "./columns/four";
import twelve from "./columns/twelve";
import twentyOne from "./columns/twentyOne";
import thirteen from "./columns/thirteen";
import thrityOne from "./columns/thirtyOne";
import hundredTwelve from "./columns/hundredTwelve";
import twoHundredEleven from "./columns/twoHundredEleven";

export const resolve = (cols: string) => {
  let resolvedCols = [];
  let type = null;

  if (cols === "100") {
    resolvedCols = cloneStructure(one);
  } else if (cols === "50-50") {
    resolvedCols = cloneStructure(two);
  } else if (cols === "33.33-33.33-33.33") {
    resolvedCols = cloneStructure(three);
  } else if (cols === "25-25-25-25") {
    resolvedCols = cloneStructure(four);
  } else if (cols === "40-60") {
    resolvedCols = cloneStructure(twelve);
  } else if (cols === "60-40") {
    resolvedCols = cloneStructure(twentyOne);
  } else if (cols === "25-75") {
    resolvedCols = cloneStructure(thirteen);
  } else if (cols === "75-25") {
    resolvedCols = cloneStructure(thrityOne);
  } else if (cols === "25-25-50") {
    resolvedCols = cloneStructure(hundredTwelve);
  } else if (cols === "50-25-25") {
    resolvedCols = cloneStructure(twoHundredEleven);
  } else if (cols == "products") {
    resolvedCols = cloneStructure(product);
    type = "products";
  }

  return {
    structure: resolvedCols,
    type: type,
  };
};

const cloneStructure = (structure: unknown) => {
  return JSON.parse(JSON.stringify(structure));
};
